import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f5eb2fca"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dialog-footer"
};
import { useVModel } from '@vueuse/core';
import { ref, watch } from 'vue';
export default {
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean
    },
    item: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue', 'confirm'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const isVisible = useVModel(props);
    const form = ref({
      name: '',
      url: '',
      parentId: '',
      tag: [],
      type: 1
    });
    watch(() => props.item, item => {
      if (item.id) {
        form.value = {
          ...item,
          tag: item.tag.split(',')
        };
      } else {
        form.value = {
          name: '',
          url: '',
          parentId: '',
          tag: [],
          type: 1
        };
      }
    }, {
      immediate: true,
      deep: true
    });
    const typeArr = ref([{
      name: '菜单',
      type: 1
    }, {
      name: '按钮',
      type: 2
    }]);
    const tagArr = ref(['GET', 'POST', 'PUT', 'DELETE']);
    const formRef = ref(null);
    const onConfirmHandler = () => {
      emit('confirm', form.value);
      isVisible.value = false;
    };

    // watch(isVisible, (val) => {
    //   if (!val) {
    //     formRef.value.resetFields()
    //     form.value = ref({
    //       name: '',
    //       url: '',
    //       parentId: '',
    //       tag: [],
    //       type: 1
    //     })
    //   }
    // })

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        title: (__props.item.id ? '修改' : '新增') + '权限',
        modelValue: _unref(isVisible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(isVisible) ? isVisible.value = $event : null),
        onClosed: _cache[6] || (_cache[6] = $event => isVisible.value = false),
        "close-on-click-modal": false,
        class: "dialog-class"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => isVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: onConfirmHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          "label-width": "150px",
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "权限名"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "路径"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.url,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.url = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "标签"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              multiple: "",
              modelValue: form.value.tag,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.tag = $event),
              placeholder: "请选择标签",
              style: {
                "width": "340px"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagArr.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item,
                  label: item,
                  value: item
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "类型"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.value.type,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.type = $event),
              placeholder: "请选择类型"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeArr.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.type,
                  label: item.name,
                  value: item.type
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["title", "modelValue"])]);
    };
  }
};